import api from "./api";

class BOMService {
    getDashboard(archived = false, projectId = null) {
        const params = { archived: archived ? "true" : "false" };
        if (projectId) params.project = projectId;
        return api.get("/api/bom-dashboard/", { params });
    }

    listLines(projectId, bomId) {
        return api.get(`/api/projects/${projectId}/boms/${bomId}/lines/`);
    }

    pullStock(projectId, bomId, lineId, quantity) {
        const body = quantity === undefined || quantity === null ? {} : { quantity };
        return api.post(`/api/projects/${projectId}/boms/${bomId}/lines/${lineId}/pull_stock/`, body);
    }

    unpullStock(projectId, bomId, lineId, quantity) {
        const body = quantity === undefined || quantity === null ? {} : { quantity };
        return api.post(`/api/projects/${projectId}/boms/${bomId}/lines/${lineId}/unpull_stock/`, body);
    }
}

export default new BOMService();
